/**
 * Gating de pasarelas de pago.
 *
 * Wompi (COP) está SIEMPRE activo. Stripe (USD) solo debe mostrarse cuando esté listo para
 * activarse: requiere el flag de build `REACT_APP_STRIPE_ENABLED=true` en el front Y la
 * configuración del backend (`PAYMENTS_STRIPE_ENABLED=true` + llaves de Stripe). Mientras no se
 * cumpla, ninguna UI específica de Stripe (p. ej. el "Stripe Price ID" del plan) debe aparecer.
 *
 * En el lado del cliente, además, el checkout ya se gatea por `gatewayEnabled` (lo entrega el
 * backend según geolocalización), así que un usuario USD no verá el pago por Stripe si está apagado.
 */
export const STRIPE_ENABLED = process.env.REACT_APP_STRIPE_ENABLED === 'true';

export default STRIPE_ENABLED;
